<template>
	<div :class="classObj" class="app-wrapper" :style="{ '--current-color': theme }">
		<div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutSide" />
		<sidebar class="sidebar-container" />
		<div :class="{ hasTagsView: needTagsView }" class="main-container">
			<div :class="{ 'fixed-header': fixedHeader }">
				<navbar @setLayout="setLayout" />
				<tags-view v-if="needTagsView" />
			</div>
			<app-main />
			<settings ref="settingRef" />
		</div>
	</div>
</template>

<script setup>
import { useWindowSize } from '@vueuse/core'
import Sidebar from './components/Sidebar/index.vue'
import { AppMain, Navbar, Settings, TagsView } from './components'

const store = useStore()
const theme = computed(() => store.state.settings.theme)
const sidebar = computed(() => store.state.app.sidebar)
const device = computed(() => store.state.app.device)
const needTagsView = computed(() => store.state.settings.tagsView)
const fixedHeader = computed(() => store.state.settings.fixedHeader)

const classObj = computed(() => ({
	hideSidebar: !sidebar.value.opened,
	openSidebar: sidebar.value.opened,
	withoutAnimation: sidebar.value.withoutAnimation,
	mobile: device.value === 'mobile'
}))

const { width, height } = useWindowSize()
const designWith = 992 // refer to Bootstrap's responsive design
const settingRef = ref(null)

function handleClickOutSide() {
	store.dispatch('app/closeSideBar', { withoutAnimation: false })
}

function setLayout() {
	settingRef.value.openSetting()
}

watchEffect(() => {
	if (device.value === 'mobile' && sidebar.value.opened) {
		store.dispatch('app/closeSideBar', { withoutAnimation: false })
	}
	if (width.value - 1 < designWith) {
		store.dispatch('app/toggleDevice', 'mobile')
		store.dispatch('app/closeSideBar', { withoutAnimation: true })
	} else {
		store.dispatch('app/toggleDevice', 'desktop')
	}
})
</script>

<style scoped lang="scss">
@import '@/assets/styles/mixin.scss';
@import '@/assets/styles/variables.module.scss';

.app-wrapper {
	@include clearfix;
	position: relative;
	height: 100%;
	width: 100%;

	&.mobile.openSidebar {
		position: fixed;
		top: 0;
	}
}

.drawer-bg {
	background: #000;
	opacity: 0.3;
	width: 100%;
	top: 0;
	height: 100%;
	position: absolute;
	z-index: 999;
}

.fixed-header {
	position: fixed;
	top: 0;
	right: 0;
	z-index: 9;
	width: calc(100% - #{$base-sidebar-width});
	transition: width 0.28s;
}

.hideSidebar .fixed-header {
	width: calc(100% - 54px);
}

.mobile .fixed-header {
	width: 100%;
}
</style>
